import {
  TGetRecommendationsByNewbuildingResponse,
  fetchGetRecommendationsByNewbuilding,
} from 'shared/repositories/newbuilding-search/v1/get-recommendations-by-newbuilding';

import { ResponseError } from '../../errors';
import { prepareSimilarNewobjects } from '../../mappers/prepareSimilarNewobjects';
import { IApplicationContext } from '../../types/applicationContext';
import { ISimilarNewobject } from '../../types/similarNewobjects';

interface IParameters {
  newbuildingId: number;
}

export async function fetchSimilarNewobjects(
  context: IApplicationContext,
  parameters: IParameters,
): Promise<ISimilarNewobject[] | null> {
  const { httpApi, logger } = context;

  try {
    const similarNewobjectsResponse: TGetRecommendationsByNewbuildingResponse =
      await fetchGetRecommendationsByNewbuilding({
        httpApi,
        parameters,
      });

    if (similarNewobjectsResponse.statusCode !== 200) {
      throw new ResponseError({
        domain: 'fetchSimilarNewobjects',
        message: similarNewobjectsResponse.response?.message || '',
        details: { errors: JSON.stringify(similarNewobjectsResponse.response?.errors) },
      });
    }

    return prepareSimilarNewobjects(similarNewobjectsResponse.response);
  } catch (ex) {
    logger.warning(ex, {
      degradation: 'Similar newobjects',
    });

    return null;
  }
}
